import React, { useState } from 'react';
import PropTypes from 'prop-types';
import FormGenerator from '../../FormBuilder/FormGenerator';
import { findAllFormErrors } from '../../helpers/formUtils';
import { useDispatch, useSelector } from 'react-redux';
import { setRegistrationData } from '../../../redux/actions/rootAction';
import { useRegistrationData } from './useRegistrationData';

export default function RegistrationForm(props) {
  const { showFormErrors } = props;

  const dispatch = useDispatch();

  const { preparedStructure, registrationData } = useRegistrationData(
    props.signatureFieldId,
    props.signatureFields,
    props.currentRecipientData
  );
  const userRegistrationData = useSelector(state => state.registrationData);

  const [selectedIndex, setSelectedIndex] = useState(0);

  const updateFormResult = (item, value) => {
    const newData = new Map(userRegistrationData);
    newData.set(item.id, value);
    dispatch(setRegistrationData(newData));
  };

  return (
    <div className={'quickForm'}>
      <FormGenerator
        showPopupsInPortal={true}
        activeElementIndex={selectedIndex}
        desktop={window.isDesktop}
        quickForm={true}
        formResult={registrationData}
        formStructure={preparedStructure}
        formErrors={findAllFormErrors([preparedStructure], registrationData)}
        showRequiredErrors={showFormErrors}
        onAnyChange={updateFormResult}
        onItemFocus={item => setSelectedIndex(item.elementIndex)}
        onItemClick={item => setSelectedIndex(item.elementIndex)}
      />
    </div>
  );
}

RegistrationForm.propTypes = {
  signatureFieldId: PropTypes.string,
  signatureFields: PropTypes.array,
  showFormErrors: PropTypes.bool,
  currentRecipientData: PropTypes.object
};
